// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3ldDe","gfeWrapper":"CalendarEvent_gfeWrapper__3FBxy"};